import * as axiosHelper from "../api_helper";

export const getStrategies = async () => {
  const data = await axiosHelper.get("/strategy");
  if (data.isError) {
    throw new Error(data.isError);
  }
  return data?.result;
};
